import { jsx as _jsx } from "react/jsx-runtime";
export const SplineEmbed = ({ contentInfo }) => {
    return (_jsx("iframe", { loading: "lazy", src: contentInfo.url, style: {
            aspectRatio: '1 / 1',
            border: 'none',
            borderRadius: 6,
            boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
            height: 500,
            maxWidth: '100%',
            width: '100%',
        } }));
};
//# sourceMappingURL=SplineEmbed.js.map